import { useSortable } from '@dnd-kit/sortable';
import { Arguments } from '@dnd-kit/sortable/dist/hooks/useSortable';
import { CSS } from '@dnd-kit/utilities';
import { CSSProperties } from 'react';

export const useSorterItem = (props?: Arguments) => {
  const { attributes, listeners, isDragging, transform, transition, setNodeRef } = useSortable(
    props ?? { id: 0 },
  );

  const style: CSSProperties = {
    transform: transform
      ? CSS.Transform.toString({
          ...transform,
          scaleX: 1,
          scaleY: 1,
        })
      : undefined,
    opacity: isDragging ? 0.5 : 1,
    transition: transition || undefined,
  };

  return {
    sortStyle: props ? style : undefined,
    setNodeRef: props ? setNodeRef : undefined,
    listeners,
    attributes,
    isDragging,
  };
};
